var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-flex"},[_c('player-avatar',{attrs:{"player":_vm.player,"scale":2}}),_c('div',{staticClass:"username"},[_vm._v(_vm._s(_vm.player.username))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }